document.addEventListener("DOMContentLoaded", function () {
    /**************
     Mega Menu Panels
     ***************/

    // outside click closes any open mega menu
    document.addEventListener("click", e => {
        if (e.target.closest(".headerNavLinkContent.open")) {
            return;
        }
        document.querySelectorAll(".headerNavLinkContent.open").forEach(closeMegaMenu);
    });

    // ESC closes any open mega menu and the search dialog (non-modal dialogs don't close on ESC on their own)
    document.addEventListener("keydown", e => {
        if (e.key !== "Escape") {
            return;
        }
        document.querySelectorAll(".headerNavLinkContent.open").forEach(closeMegaMenu);
        closeSearch();
    });

    // lock body scroll whenever a mega menu is showing - pinned open (click/keyboard) or open on hover - matching the search dialog and mini-cart
    function syncMegaMenuScroll() {
        const showing = document.querySelector(".headerNavLinkContent.open, .headerNavLinkContent:hover .headerNavLinkContentExpanded");
        document.body.classList.toggle("noScroll", !!showing);
    }

    // collapse the expanded panel and its cards so the menu reopens fresh next time
    function resetMegaMenuPanels(content) {
        content.querySelectorAll(".headerNavLinkContentExpandedPanel.active").forEach(panel => panel.classList.remove("active"));
        content.querySelectorAll(".headerNavLinkContentExpandedGroupsItem").forEach(card => card.setAttribute("aria-expanded", "false"));
    }

    // close a mega menu and reset its panels
    function closeMegaMenu(content) {
        content.classList.remove("open");
        const title = content.querySelector(".headerNavLinkContentTitle[aria-controls]");
        if (title) {
            title.setAttribute("aria-expanded", "false");
            // if focus is still on an element inside the dropdown, move it back to the button that opened it - otherwise the focused element is invisible and the next Tab press starts from somewhere the user can't see
            if (content.contains(document.activeElement) && document.activeElement !== title) {
                title.focus();
            }
        }
        resetMegaMenuPanels(content);
        syncMegaMenuScroll();
    }

    // open the panel paired with a card: reset the others, position it against the card, mark it active.
    // shared by click (touch/keyboard) and hover so both entry points align and place the panel identically
    function openCardPanel(content, card, panel) {
        resetMegaMenuPanels(content);
        if (!panel) {
            return;
        }
        // align the panel's top with the card that opens it (both offset from the expanded dropdown).
        // the card list scrolls inside .headerNavLinkContentExpandedGroups, so subtract that scroll to track the card's visible position
        const groups = card.closest(".headerNavLinkContentExpandedGroups");
        const cardTop = card.offsetTop - (groups ? groups.scrollTop : 0);
        panel.style.top = cardTop + "px";
        // if that alignment runs the panel off the bottom of the screen, lift it up just enough to fit - but never far enough to push its top off the top edge
        const margin = 16;
        const rect = panel.getBoundingClientRect();
        const overflow = rect.bottom - (window.innerHeight - margin);
        if (overflow > 0) {
            const shift = Math.min(overflow, Math.max(0, rect.top - margin));
            panel.style.top = cardTop - shift + "px";
        }
        panel.classList.add("active");
        card.setAttribute("aria-expanded", "true");
    }

    // cards and panels are rendered in the same order - pair them by index
    document.querySelectorAll(".headerNavLinkContent").forEach(content => {
        const title = content.querySelector(".headerNavLinkContentTitle[aria-controls]");
        const cards = content.querySelectorAll(".headerNavLinkContentExpandedGroupsItem");
        const panels = content.querySelectorAll(".headerNavLinkContentExpandedPanel");

        // only button titles toggle the pinned-open state on click; link titles navigate to their URL instead
        if (title && title.tagName === "BUTTON") {
            title.addEventListener("click", e => {
                e.stopPropagation();
                const wasOpen = content.classList.contains("open");
                document.querySelectorAll(".headerNavLinkContent.open").forEach(closeMegaMenu);
                if (!wasOpen) {
                    content.classList.add("open");
                    title.setAttribute("aria-expanded", "true");
                }
                syncMegaMenuScroll();
            });
        }

        cards.forEach((card, index) => {
            // hover opens the paired panel (desktop). the menu is already held open by :hover, so no pinning here;
            // mouseleave on the content resets the panels when the pointer leaves entirely
            card.addEventListener("mouseenter", () => {
                const matching = panels[index];
                if (matching && matching.classList.contains("active")) {
                    return;
                }
                openCardPanel(content, card, matching);
            });

            card.addEventListener("click", e => {
                e.stopPropagation();
                const matching = panels[index];
                const wasOpen = matching && matching.classList.contains("active");
                if (matching && !wasOpen) {
                    openCardPanel(content, card, matching);
                } else {
                    resetMegaMenuPanels(content);
                }
                // pin the menu open on submenu open until outside click
                content.classList.add("open");
                if (title) {
                    title.setAttribute("aria-expanded", "true");
                }
                syncMegaMenuScroll();
                // keyboard activation (Enter/Space) reports detail 0; a real mouse click reports >= 1.
                // on keyboard open, move focus into the freshly opened panel so the next Tab continues inside the submenu rather than skipping to the next card
                if (matching && !wasOpen && e.detail === 0) {
                    const firstLink = matching.querySelector("a, button");
                    if (firstLink) {
                        firstLink.focus();
                    }
                }
            });
        });

        // hover opens the dropdown via CSS alone, so mirror that into the scroll lock on enter and release it on leave (the pinned .open state keeps it locked)
        content.addEventListener("mouseenter", syncMegaMenuScroll);

        // reset the active panel - ignore pinned state
        content.addEventListener("mouseleave", () => {
            syncMegaMenuScroll();
            if (content.classList.contains("open")) {
                return;
            }
            resetMegaMenuPanels(content);
        });

        // keyboard parity with hover: opening is driven by the same .open class as a click, so focus and hover share every CSS rule
        if (content.querySelector(".headerNavLinkContentExpanded")) {
            // keyboard focus entering the menu from outside opens it (like hover); mouse focus is ignored since :hover already covers it, and an internal move (e.g. Esc returning focus to the title) must not reopen it
            content.addEventListener("focusin", e => {
                if (content.contains(e.relatedTarget) || !e.target.matches(":focus-visible")) {
                    return;
                }
                document.querySelectorAll(".headerNavLinkContent.open").forEach(closeMegaMenu);
                content.classList.add("open");
                if (title) {
                    title.setAttribute("aria-expanded", "true");
                }
                syncMegaMenuScroll();
            });

            // focus leaving the menu entirely closes and resets it (mirrors mouseleave) so a panel opened by Enter doesn't stay pinned after tabbing away
            content.addEventListener("focusout", e => {
                if (content.contains(e.relatedTarget)) {
                    return;
                }
                closeMegaMenu(content);
            });
        }
    });

    /**************
     Mobile Nav
     ***************/

    const slider = document.querySelector("#slider");
    const sliderContent = document.querySelector("#sliderContent");
    const sliderTitle = document.querySelector("#sliderTitle");
    const sliderBack = document.querySelector("#sliderBack");
    const sliderRootPanel = document.querySelector(".sliderPanelRoot");

    // tap a top-level card → slide to that link's sub-menu panel
    document.querySelectorAll(".sliderRootCard").forEach(card => {
        card.addEventListener("click", () => {
            const handle = card.dataset.targetLink;
            // single-group links skip the redundant group-selection panel and open the group's items directly at level 1, so Back returns to root
            if (card.dataset.singleGroup === "true") {
                const groupPanel = document.querySelector(`.sliderPanelGroup[data-link="${handle}"][data-group="0"]`);
                if (!groupPanel) {
                    return;
                }
                showSliderPanel(groupPanel, card.dataset.title || "", 1);
                return;
            }
            const target = document.querySelector(`.sliderPanelLink[data-link="${handle}"]`);
            if (!target) {
                return;
            }
            showSliderPanel(target, card.dataset.title || "", 1);
        });
    });

    // clicking a group card inside a link panel opens that group's panel
    document.querySelectorAll(".sliderLinkCard").forEach(card => {
        card.addEventListener("click", () => {
            const linkPanel = card.closest(".sliderPanelLink");
            const handle = linkPanel.dataset.link;
            const groupIndex = card.dataset.targetGroup;
            const target = document.querySelector(`.sliderPanelGroup[data-link="${handle}"][data-group="${groupIndex}"]`);
            if (!target) {
                return;
            }
            showSliderPanel(target, card.dataset.title || "", 2);
        });
    });

    // reveal a target panel; forward sends the outgoing panel out to the left, back sends it out to the right
    function showSliderPanel(target, title, level, direction = "forward") {
        const current = document.querySelector(".sliderPanel.active");
        if (current && current !== target) {
            current.classList.remove("active");
            current.classList.add(direction === "back" ? "next" : "previous");
        }
        target.classList.remove("previous", "next");
        target.classList.add("active");
        sliderContent.dataset.level = String(level);
        sliderTitle.textContent = title;
    }

    // back button: level 2 → matching link panel; level 1 → root
    sliderBack.addEventListener("click", () => {
        const level = Number(sliderContent.dataset.level || "0");
        if (level === 2) {
            const groupPanel = document.querySelector(".sliderPanelGroup.active");
            const linkPanel = document.querySelector(`.sliderPanelLink[data-link="${groupPanel.dataset.link}"]`);
            const linkCard = document.querySelector(`.sliderRootCard[data-target-link="${groupPanel.dataset.link}"]`);
            showSliderPanel(linkPanel, linkCard ? linkCard.dataset.title || "" : "", 1, "back");
        } else if (level === 1) {
            showSliderPanel(sliderRootPanel, "", 0, "back");
        }
    });

    // reset all panels back to the root view
    function resetSlider() {
        document.querySelectorAll(".sliderPanel").forEach(panel => {
            panel.classList.remove("active", "previous");
        });
        sliderRootPanel.classList.add("active");
        sliderContent.dataset.level = "0";
        sliderTitle.textContent = "";
    }

    // open nav
    function openNav() {
        slider.showModal();
        document.body.classList.add("noScroll");
        document.querySelectorAll(".openNav").forEach(el => el.setAttribute("aria-expanded", "true"));
    }

    // close nav
    function closeNav() {
        slider.close();
    }

    // dialog close event
    slider.addEventListener("close", () => {
        document.body.classList.remove("noScroll");
        document.querySelectorAll(".openNav").forEach(el => el.setAttribute("aria-expanded", "false"));
        resetSlider();
    });

    // close on backdrop click only
    slider.addEventListener("click", e => {
        if (e.target === slider) {
            closeNav();
        }
    });

    // open nav event listener
    document.querySelectorAll(".openNav").forEach(element => {
        element.addEventListener("click", openNav);
    });

    // close nav event listener
    document.querySelectorAll(".closeNav").forEach(element => {
        element.addEventListener("click", closeNav);
    });

    /**************
     Header Search
     ***************/

    const header = document.querySelector("#header");
    const headerSearch = document.querySelector("#headerSearch");
    const headerSearchInput = document.querySelector("#headerSearchFormInput");

    // iOS Safari sometimes fails to restore zoom after focusing an input with font-size < 16px inside a dialog
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    const originalViewportContent = viewportMeta?.getAttribute("content") ?? "";
    headerSearchInput.addEventListener("focus", () => {
        viewportMeta?.setAttribute("content", `${originalViewportContent}, maximum-scale=1`);
    });
    headerSearchInput.addEventListener("blur", () => {
        viewportMeta?.setAttribute("content", originalViewportContent);
    });

    // keep --header-height in sync with the header's visible bottom edge for backdrop positioning
    function syncHeaderHeight() {
        const visibleBottom = Math.max(0, header.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty("--header-height", `${visibleBottom}px`);
    }

    syncHeaderHeight();
    window.addEventListener("resize", syncHeaderHeight);
    window.addEventListener("scroll", syncHeaderHeight, {passive: true});

    // hide the header while scrolling down, show it again as soon as the user scrolls up
    let lastScrollY = window.scrollY;

    function syncHeaderVisibility() {
        const currentScrollY = window.scrollY;

        // keep the header pinned while a mega menu is open (click or keyboard) or hovered open so its backdrop and blur stay active until the menu closes
        if (document.querySelector(".headerNavLinkContent.open, .headerNavLinkContent:hover .headerNavLinkContentExpanded")) {
            header.classList.remove("scrolledDown");
            lastScrollY = currentScrollY;
            return;
        }

        // ignore rubber-band overscroll and always show the header at the top of the page
        if (currentScrollY <= 0) {
            header.classList.remove("scrolledDown");
            lastScrollY = 0;
            return;
        }

        // only hide once the header is fully scrolled past, so it never disappears mid-view
        if (currentScrollY > lastScrollY && currentScrollY > header.offsetHeight) {
            header.classList.add("scrolledDown");
        } else if (currentScrollY < lastScrollY) {
            header.classList.remove("scrolledDown");
        }
        lastScrollY = currentScrollY;
    }

    window.addEventListener("scroll", syncHeaderVisibility, {passive: true});

    function openSearch() {
        if (!headerSearch.open) {
            // non-modal so the header bar can paint in front of the panel - it slides out from behind the bar
            headerSearch.show();
            document.body.classList.add("noScroll");
            if (window.matchMedia("(min-width: 801px)").matches) {
                headerSearchInput.focus();
            } else {
                headerSearch.focus();
            }
        }
    }

    function closeSearch() {
        if (headerSearch.open) {
            headerSearch.close();
        }
    }

    document.querySelectorAll(".openSearch").forEach(element => {
        element.addEventListener("click", openSearch);
    });

    document.querySelectorAll(".closeSearch").forEach(element => {
        element.addEventListener("click", closeSearch);
    });

    // clean up when the dialog closes (ESC, backdrop click, etc.)
    headerSearch.addEventListener("close", () => {
        headerSearchInput.value = "";
        clearResults();
        document.body.classList.remove("noScroll");
    });

    // close when the dimmed backdrop is clicked (non-modal dialogs have no native ::backdrop to catch outside clicks)
    const headerNavBackdrop = document.querySelector("#headerNavBackdrop");
    headerNavBackdrop.addEventListener("click", closeSearch);

    /**************
     Header Search Results
     ***************/

    const headerSearchForm = document.querySelector("#headerSearchForm");
    const headerSearchResults = document.querySelector(".headerSearchResults");
    const headerSearchResultsBody = headerSearchResults.querySelector(".headerSearchResultsBody");
    const headerSearchStatus = document.querySelector("#headerSearchStatus");
    const SEARCH_SUGGESTIONS_SECTION_ID = "theme-search-suggestions";

    let searchDebounce = null;
    let activeSearchController = null;

    // the search term backing the current results - filter commits re-search with this term
    let currentSearchTerm = "";

    // on-sale toggle - client-side, since "on sale" is live price data that S&D can't filter on
    let onSaleOnly = false;

    // swiper instance for the suggestions product grid - rebuilt each time the results body is re-rendered
    let suggestionsGridSwiper = null;

    // turn the freshly injected suggestions grid into a free-scrolling swiper (matches the mini-cart upsells carousel)
    function initSuggestionsGridSwiper() {
        // tear down the previous instance since its element was just replaced by the innerHTML wipe
        if (suggestionsGridSwiper) {
            suggestionsGridSwiper.destroy(true, true);
            suggestionsGridSwiper = null;
        }
        const grid = headerSearchResultsBody.querySelector(".searchSuggestionsGrid");
        if (!grid) {
            return;
        }
        suggestionsGridSwiper = new Swiper(grid, {
            slidesPerView: "auto",
            spaceBetween: 10,
            freeMode: true,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true
            },
            observer: true,
            observeParents: true
        });
    }

    let resizeAnimation = null;

    // animate the dialog's height change
    function animateDialogResize(mutate) {
        const startHeight = headerSearch.offsetHeight;
        mutate();
        const endHeight = headerSearch.offsetHeight;
        if (resizeAnimation) {
            resizeAnimation.cancel();
        }
        resizeAnimation = headerSearch.animate(
            [{height: `${startHeight}px`}, {height: `${endHeight}px`}],
            {duration: 400, easing: "ease"}
        );
    }

    // hide results and bring back the trending view
    function clearResults() {
        animateDialogResize(() => {
            headerSearch.classList.remove("hasResults");
            headerSearchResults.setAttribute("aria-hidden", "true");
            // return any portaled dropdown to the body first so the wipe removes it instead of orphaning it on #headerSearch
            closeAllDropdowns();
            // tear down the grid swiper before wiping its element so it doesn't leak listeners
            if (suggestionsGridSwiper) {
                suggestionsGridSwiper.destroy(true, true);
                suggestionsGridSwiper = null;
            }
            headerSearchResultsBody.innerHTML = "";
        });
        currentSearchTerm = "";
        onSaleOnly = false;
        headerSearchResultsBody.classList.remove("onSaleOnly");
        if (headerSearchStatus) {
            headerSearchStatus.textContent = "";
        }
    }

    // fetch a /search URL as a rendered section and drop it into the results pane
    async function fetchSuggestionsSection(searchUrl) {
        // cancel any in-flight request so a slow response can't overwrite a newer one
        if (activeSearchController) {
            activeSearchController.abort();
        }
        activeSearchController = new AbortController();

        // ask for the suggestions section and include both products and pages
        const u = new URL(searchUrl, window.location.origin);
        u.searchParams.set("section_id", SEARCH_SUGGESTIONS_SECTION_ID);
        u.searchParams.set("type", "product,page");

        try {
            const html = await fetch(u.pathname + u.search, {signal: activeSearchController.signal}).then(r => r.text());

            animateDialogResize(() => {
                headerSearch.classList.add("hasResults");
                headerSearchResults.setAttribute("aria-hidden", "false");
                // return any portaled dropdown to the body first so the wipe removes it instead of orphaning it on #headerSearch
                closeAllDropdowns();
                headerSearchResultsBody.innerHTML = html;
            });
            // wrap the freshly injected product grid in a swiper so it scrolls with mouse/drag, not just shift-scroll
            initSuggestionsGridSwiper();
            // the freshly rendered on-sale chip needs its state re-synced after a re-fetch
            applyOnSale();
            // announce the result count to screen readers via the persistent live region
            if (headerSearchStatus) {
                const countEl = headerSearchResultsBody.querySelector(".searchSuggestionsMetaCount");
                const emptyEl = headerSearchResultsBody.querySelector(".searchSuggestionsEmpty");
                headerSearchStatus.textContent = (countEl || emptyEl)?.textContent.trim() ?? "";
            }
        } catch (error) {
            if (error.name === "AbortError") {
                return;
            }
            console.error(error);
        }
    }

    // run a fresh search with no filters applied
    async function runProductSearch(term) {
        const query = term.trim();
        if (!query) {
            clearResults();
            return;
        }
        currentSearchTerm = query;
        onSaleOnly = false;
        await fetchSuggestionsSection(`/search?q=${encodeURIComponent(query)}`);
    }

    // debounce so we only search after the user pauses typing
    headerSearchInput.addEventListener("input", () => {
        clearTimeout(searchDebounce);
        const value = headerSearchInput.value.trim();
        if (!value) {
            clearResults();
            return;
        }
        searchDebounce = setTimeout(() => runProductSearch(value), 200);
    });

    // search in place on enter instead of navigating to /search
    headerSearchForm.addEventListener("submit", e => {
        e.preventDefault();
        clearTimeout(searchDebounce);
        const value = headerSearchInput.value.trim();
        if (!value) {
            clearResults();
            return;
        }
        runProductSearch(value);
    });

    // reset button → back to trending
    headerSearchForm.addEventListener("reset", () => {
        clearResults();
    });

    // clicking a trending term runs it as a search
    const headerSearchTrending = document.querySelector(".headerSearchTrending");
    if (headerSearchTrending) {
        headerSearchTrending.addEventListener("click", e => {
            const item = e.target.closest(".headerSearchTrendingGridItem");
            if (!item) {
                return;
            }
            headerSearchInput.value = item.dataset.term;
            runProductSearch(item.dataset.term);
        });
    }

    // clicking a filter toggles a pending selection; the Update Search button re-searches with all selections applied.
    // bound on #headerSearch (not the results body) so it still catches clicks inside an open dropdown, which is
    // portaled out to #headerSearch while open so no scrolling ancestor can clip it
    headerSearch.addEventListener("click", event => {
        // Update Search → re-search with every active filter selection
        const applyBtn = event.target.closest(".searchSuggestionsMetaFiltersItemDropdownApply");
        if (applyBtn) {
            applyFilters();
            return;
        }

        // category option - multi-select toggle; no selection means "show all" (this generic item class is category-only)
        const categoryOption = event.target.closest(".searchSuggestionsMetaFiltersItemDropdownItem");
        if (categoryOption) {
            categoryOption.classList.toggle("active");
            return;
        }

        // color swatch - toggle pending
        const swatch = event.target.closest(".searchSuggestionsMetaFiltersItemDropdownColorGridSwatch");
        if (swatch) {
            swatch.classList.toggle("active");
            return;
        }

        // trigger button toggles the dropdown
        const trigger = event.target.closest(".searchSuggestionsMetaFiltersItemTrigger");
        if (trigger) {
            const filterEl = trigger.closest(".searchSuggestionsMetaFiltersItem");
            const wasOpen = filterEl.classList.contains("dropdownOpen");
            closeAllDropdowns();
            if (!wasOpen) {
                openDropdown(filterEl);
            }
            return;
        }

        // on-sale toggle - client-side filter on live sale status, applied instantly
        const onSaleFilter = event.target.closest(".searchSuggestionsMetaFiltersItem[data-filter=\"on-sale\"]");
        if (onSaleFilter) {
            onSaleOnly = !onSaleOnly;
            applyOnSale();
        }
    });

    // reflect the on-sale toggle onto the persistent results container (its class survives a re-fetch) and the chip
    function applyOnSale() {
        headerSearchResultsBody.classList.toggle("onSaleOnly", onSaleOnly);
        const chip = headerSearchResultsBody.querySelector(".searchSuggestionsMetaFiltersItem[data-filter=\"on-sale\"]");
        if (chip) {
            chip.classList.toggle("active", onSaleOnly);
        }
        syncResultCounts();
    }

    // keep the result counts in step with the on-sale toggle (pages are unaffected by it)
    function syncResultCounts() {
        const grid = headerSearchResultsBody.querySelector(".searchSuggestionsGrid");
        const onSaleCount = grid ? grid.querySelectorAll(".searchSuggestionsGridItem[data-on-sale]").length : 0;
        const pageCount = headerSearchResultsBody.querySelectorAll(".searchSuggestionsPagesItem").length;

        // products section header → on-sale product count
        headerSearchResultsBody.querySelectorAll(".searchSuggestionsSectionHeaderTitle").forEach(el => {
            if (!el.textContent.trim().startsWith("PRODUCTS")) {
                return;
            }
            // cache the server-rendered text so toggling off restores it exactly, including any "+"
            if (el.dataset.fullText === undefined) {
                el.dataset.fullText = el.textContent;
            }
            el.textContent = onSaleOnly
                ? el.dataset.fullText.replace(/\d+\+?/, String(onSaleCount))
                : el.dataset.fullText;
        });

        // total "N RESULTS FOR ..." count → on-sale products + pages
        const countEl = headerSearchResultsBody.querySelector(".searchSuggestionsMetaCount");
        if (countEl) {
            if (countEl.dataset.fullText === undefined) {
                countEl.dataset.fullText = countEl.textContent;
            }
            countEl.textContent = onSaleOnly
                ? countEl.dataset.fullText.replace(/\d+\+?/, String(onSaleCount + pageCount))
                : countEl.dataset.fullText;
        }
    }

    // set while dragging a price thumb so the click-outside handler doesn't fire on pointerup
    let isSliderDragging = false;

    // click outside an open dropdown closes it
    document.addEventListener("click", event => {
        if (isSliderDragging) {
            return;
        }
        if (event.target.closest(".searchSuggestionsMetaFiltersItem.hasDropdown")) {
            return;
        }
        // the open dropdown is portaled out of its filter, so guard it separately or selecting an option would close it
        if (event.target.closest(".searchSuggestionsMetaFiltersItemDropdown")) {
            return;
        }
        closeAllDropdowns();
    });

    // the one open dropdown, tracked because it's portaled out of its filter while open (see openDropdown)
    let openFilterEl = null;
    let openDropdownEl = null;

    // open a filter's dropdown: lift it out of every clipping ancestor (the results scroll pane and, on mobile,
    // the horizontal chip scroller), then show and position it. it stays fixed-positioned against #headerSearch
    // via that element's transform, so its coordinates are unchanged - only the clipping chain is removed.
    function openDropdown(filterEl) {
        const dropdown = filterEl.querySelector(".searchSuggestionsMetaFiltersItemDropdown");
        if (!dropdown) {
            return;
        }
        filterEl.classList.add("dropdownOpen");
        // portal to #headerSearch (which doesn't clip) and show via a class on the dropdown itself,
        // since the descendant-based display rule no longer matches once it's moved out of the filter
        headerSearch.appendChild(dropdown);
        dropdown.classList.add("open");
        openFilterEl = filterEl;
        openDropdownEl = dropdown;
        positionDropdown(filterEl, dropdown);
        // build the price slider on first open - it needs real layout to measure
        if (filterEl.dataset.filter === "price" && !filterEl.dataset.sliderReady) {
            setupPriceSlider(filterEl, dropdown);
        }
    }

    function closeAllDropdowns() {
        headerSearchResultsBody.querySelectorAll(".searchSuggestionsMetaFiltersItem.dropdownOpen").forEach(filterEl => {
            filterEl.classList.remove("dropdownOpen");
        });
        // return the portaled dropdown to its filter so re-render and re-open stay consistent
        if (openDropdownEl) {
            openDropdownEl.classList.remove("open");
            if (openFilterEl) {
                openFilterEl.appendChild(openDropdownEl);
            }
            openFilterEl = null;
            openDropdownEl = null;
        }
    }

    // the filter's offsetParent is #headerSearch, so offsetTop/Left are already dialog-local
    function positionDropdown(filterEl, dropdown) {
        dropdown.style.top = `${filterEl.offsetTop - headerSearchResults.scrollTop + filterEl.offsetHeight + 6}px`;

        // clamp so the dropdown stays 20px in from the #headerSearch container edges
        const left = filterEl.offsetLeft - headerSearchResults.scrollLeft;
        const maxLeft = headerSearch.clientWidth - dropdown.offsetWidth - 20;
        dropdown.style.left = `${Math.max(20, Math.min(left, maxLeft))}px`;
    }

    // dropdown is fixed-positioned, so close it on scroll rather than try to track the filter
    headerSearchResults.addEventListener("scroll", closeAllDropdowns);

    /**************
     Applying Filters
     ***************/

    // gather every active filter selection into a /search URL and re-fetch the section server-side
    function applyFilters() {
        const url = new URL("/search", window.location.origin);
        url.searchParams.set("q", currentSearchTerm);

        // category + color - each active option carries its own Search & Discovery param name and value.
        // scoped to #headerSearch since an open dropdown is portaled there, outside the results body
        headerSearch
            .querySelectorAll(".searchSuggestionsMetaFiltersItemDropdownItem.active[data-filter-param], .searchSuggestionsMetaFiltersItemDropdownColorGridSwatch.active")
            .forEach(option => {
                const param = option.dataset.filterParam;
                const value = option.dataset.filterValue;
                if (param && value) {
                    url.searchParams.append(param, value);
                }
            });

        // price - only add bounds when the slider has actually narrowed the range
        const priceFilter = headerSearchResultsBody.querySelector(".searchSuggestionsMetaFiltersItem[data-filter=\"price\"]");
        if (priceFilter) {
            const absMin = Number(priceFilter.dataset.priceMin);
            const absMax = Number(priceFilter.dataset.priceMax);
            const pendingMin = Number(priceFilter.dataset.pendingMin);
            const pendingMax = Number(priceFilter.dataset.pendingMax);
            if (pendingMin > absMin) {
                url.searchParams.set(priceFilter.dataset.priceParamMin, String(pendingMin));
            }
            if (pendingMax < absMax) {
                url.searchParams.set(priceFilter.dataset.priceParamMax, String(pendingMax));
            }
        }

        closeAllDropdowns();
        void fetchSuggestionsSection(url.pathname + url.search);
    }

    /**************
     Price Range Slider
     ***************/

    // the price bounds/pending values live on the filter chip's dataset; the slider DOM lives in the dropdown,
    // which is portaled out of the chip, so it's passed in separately
    function setupPriceSlider(filterEl, dropdown) {
        const absMin = Number(filterEl.dataset.priceMin);
        const absMax = Number(filterEl.dataset.priceMax);
        const span = absMax - absMin;
        if (!(span > 0)) {
            return;
        }

        const track = dropdown.querySelector(".searchSuggestionsMetaFiltersItemDropdownPriceSliderControl");
        const range = dropdown.querySelector(".searchSuggestionsMetaFiltersItemDropdownPriceSliderControlRange");
        const valueEl = dropdown.querySelector(".searchSuggestionsMetaFiltersItemDropdownPriceSliderHeaderValue");
        const startThumb = dropdown.querySelector('[data-thumb="start"]');
        const endThumb = dropdown.querySelector('[data-thumb="end"]');

        // seed the thumbs from the currently applied range - pending defaults to the full range when nothing is applied
        let startPct = Math.max(0, Math.min(100, ((Number(filterEl.dataset.pendingMin) - absMin) / span) * 100));
        let endPct = Math.max(0, Math.min(100, ((Number(filterEl.dataset.pendingMax) - absMin) / span) * 100));

        // paint the thumbs and the green range bar from the current percentages
        function paint() {
            const trackW = track.getBoundingClientRect().width;
            const thumbW = 24;
            let startLeftPx = (startPct / 100) * trackW;
            let endLeftPx = (endPct / 100) * trackW - thumbW;
            // if the thumbs would overlap, collapse them to a touching pair on the midpoint
            if (startLeftPx + thumbW > endLeftPx) {
                const centerPx = ((startPct + endPct) / 2 / 100) * trackW;
                startLeftPx = centerPx - thumbW;
                endLeftPx = centerPx;
            }
            // keep both thumbs inside the track
            if (startLeftPx < 0) {
                endLeftPx -= startLeftPx;
                startLeftPx = 0;
            }
            if (endLeftPx > trackW - thumbW) {
                startLeftPx -= endLeftPx - (trackW - thumbW);
                endLeftPx = trackW - thumbW;
            }
            // nudge each thumb 2px inward so it sits inside the green bar
            startThumb.style.left = `${startLeftPx + 2}px`;
            endThumb.style.left = `${endLeftPx - 2}px`;
            // pin the bar to the thumb positions so it can't extend past them
            range.style.left = `${startLeftPx}px`;
            range.style.right = `${trackW - endLeftPx - thumbW}px`;
            const pendingMin = Math.round(absMin + (span * startPct) / 100);
            const pendingMax = Math.round(absMin + (span * endPct) / 100);
            filterEl.dataset.pendingMin = String(pendingMin);
            filterEl.dataset.pendingMax = String(pendingMax);
            valueEl.textContent = `$${pendingMin} - $${pendingMax}`;
        }

        // drag handler for one thumb - clamping keeps start ≤ end with a tiny gap
        function startDrag(which, pointerEvent) {
            pointerEvent.preventDefault();
            isSliderDragging = true;
            const rect = track.getBoundingClientRect();
            // small numeric gap so pending values can sit next to each other
            const gapPct = 1;

            function move(e) {
                const raw = ((e.clientX - rect.left) / rect.width) * 100;
                const clamped = Math.max(0, Math.min(100, raw));
                if (which === "start") {
                    startPct = Math.min(clamped, endPct - gapPct);
                } else {
                    endPct = Math.max(clamped, startPct + gapPct);
                }
                paint();
            }

            function up() {
                document.removeEventListener("pointermove", move);
                document.removeEventListener("pointerup", up);
                // clear on the next tick so the click event after pointerup still sees the drag flag
                setTimeout(() => {
                    isSliderDragging = false;
                }, 0);
            }

            document.addEventListener("pointermove", move);
            document.addEventListener("pointerup", up);
        }

        startThumb.addEventListener("pointerdown", e => startDrag("start", e));
        endThumb.addEventListener("pointerdown", e => startDrag("end", e));

        paint();
        filterEl.dataset.sliderReady = "1";
    }

    /**************
     Country Selector
     ***************/

    // each entry's dropdown is moved out of its normal parent (position: fixed, from the
    // trigger's live getBoundingClientRect()) while open, rather than left positioned
    // absolute within it - the mobile trigger sits inside the slider menu's slide-transition
    // container (#sliderPanels), which clips overflow, and would cut the dropdown off.
    // Desktop moves to <body>; mobile moves to #sliderContent instead of <body> - the slider
    // is a showModal() <dialog>, rendered in the browser's top layer while open, which sits
    // above all regular DOM regardless of z-index, so a <body> child would render BEHIND it.
    // #sliderContent has no overflow clipping of its own (only its #sliderPanels child does),
    // so moving there escapes the clip while staying inside the dialog's top-layer subtree.
    // "anchor" is a permanent, always-in-place marker so the dropdown has somewhere to move
    // back to on close (its own original DOM position gets vacated once it's moved out).
    const countrySelectors = [];

    document.querySelectorAll("[data-country-selector]").forEach(el => {
        const trigger = el.querySelector(".countrySelectorTrigger");
        const dropdown = el.querySelector(".countrySelectorDropdown");
        const isMobile = el.classList.contains("countrySelector--mobile");
        const anchor = document.createComment("country-selector-anchor");
        dropdown.after(anchor);

        function openCountrySelector() {
            const rect = trigger.getBoundingClientRect();
            (isMobile ? sliderContent : document.body).appendChild(dropdown);

            // measure the real height before deciding direction - hidden (not just
            // visibility:hidden) elements have no layout box, so unhide first but keep it
            // invisible to the user until it's correctly positioned
            dropdown.hidden = false;
            dropdown.style.visibility = "hidden";
            dropdown.style.position = "fixed";
            const dropdownHeight = dropdown.offsetHeight;

            // #slider (the mobile menu dialog) has its own CSS transform, which makes IT -
            // not the viewport - the containing block for any position:fixed descendant
            // inside it, including this dropdown once moved into #sliderContent. Positioning
            // it with raw viewport coordinates landed it far outside #slider's own box from
            // its own frame of reference, which forced #slider to grow a scrollbar to reach
            // it. So on mobile, top/left are computed relative to #slider's box instead.
            const origin = isMobile
                ? slider.getBoundingClientRect()
                : {top: 0, left: 0, right: window.innerWidth, bottom: window.innerHeight};

            const spaceBelow = origin.bottom - rect.bottom;
            let top;
            if (spaceBelow >= dropdownHeight + 8) {
                top = rect.bottom - origin.top + 8;
            } else {
                // not enough room below - open upward instead, but never past the top of the
                // available box either, so it's guaranteed fully visible either way
                top = Math.max(0, rect.top - origin.top - dropdownHeight - 8);
            }
            dropdown.style.top = `${top}px`;
            dropdown.style.bottom = "";

            if (isMobile) {
                dropdown.style.left = `${rect.left - origin.left}px`;
                dropdown.style.right = "";
            } else {
                dropdown.style.right = `${origin.right - rect.right}px`;
                dropdown.style.left = "";
            }

            dropdown.style.visibility = "";
            el.classList.add("open");
            trigger.setAttribute("aria-expanded", "true");
        }

        function closeCountrySelector() {
            anchor.after(dropdown);
            dropdown.hidden = true;
            dropdown.style.position = "";
            dropdown.style.top = "";
            dropdown.style.bottom = "";
            dropdown.style.left = "";
            dropdown.style.right = "";
            el.classList.remove("open");
            trigger.setAttribute("aria-expanded", "false");
        }

        trigger.addEventListener("click", () => {
            const wasOpen = el.classList.contains("open");
            countrySelectors.forEach(entry => entry.close());
            if (!wasOpen) {
                openCountrySelector();
            }
        });

        countrySelectors.push({el, dropdown, close: closeCountrySelector});
    });

    // outside click closes any open country selector - checked against the dropdown itself
    // too, since it's moved outside [data-country-selector] (to <body> or #sliderContent) while open
    document.addEventListener("click", e => {
        if (e.target.closest("[data-country-selector].open, .countrySelectorDropdown")) {
            return;
        }
        countrySelectors.forEach(entry => {
            if (entry.el.classList.contains("open")) {
                entry.close();
            }
        });
    });

    // ESC closes any open country selector dropdown
    document.addEventListener("keydown", e => {
        if (e.key !== "Escape") {
            return;
        }
        countrySelectors.forEach(entry => {
            if (entry.el.classList.contains("open")) {
                entry.close();
            }
        });
    });
});
